"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDuplicates_en_us = void 0;
function backofficeDuplicates_en_us() {
    return {
        "backoffice.duplicates.confirmopentitle": "Acknowledge",
        "backoffice.duplicates.confirmopentext": "All current changes will be lost. Do you want to continue? You can also open the duplicate in a new window instead!",
        "backoffice.duplicates.openduplicate": "open",
        "backoffice.duplicates.fillinduplicate": "Fill in"
    };
}
exports.backofficeDuplicates_en_us = backofficeDuplicates_en_us;
